import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
} from "antd";
import {
  CommonStatus,
  DeviceType,
  StatusWorking,
  TableSessionStatus,
  TableSessionType,
  UserPlan,
} from "../../constants/enum";
import { DoubleLeftOutlined, DoubleRightOutlined } from "@ant-design/icons";
import React, {
  FC,
  memo,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import _, { uniqueId } from "lodash";
import { colors, queryKeys } from "../../constants/constans";
import {
  createTableSession,
  deleteTableSession,
  getListTableSession,
  updateTableSession,
} from "../../api/tableSession";
import {
  displayStaffName,
  handleErrorMessage,
  toMinutes,
} from "utils/helper/common";
import { useMutation, useQuery, useQueryClient } from "react-query";

import Cookies from "js-cookie";
import CustomNotification from "../CustomNotification";
import ModalConfirm from "Component/Modal/ModalConfirm";
import { StaffType } from "../../types/StaffType";
import { TakuContext } from "../../providers/TakuProvider";
import { TakuTypeSettei } from "../../types/TakuTypeSettei";
import TextArea from "antd/lib/input/TextArea";
import { TimeLine } from "../TimeLine";
import classNames from "classnames";
import { getDefaultConfigOfTable } from "../../api/table";
import { getListHostCount } from "../../api/host";
import moment from "moment";
import styles from "./styles.module.scss";
import useBreakpoint from "../../hooks/useBreakPoint";
import { useCalcEndTime } from "../../hooks/useCalcEndTime";
import useDragStaff from "hooks/useDragStaff";
import useInRandom from "../../hooks/useInRandom";
import useIsMobile from "hooks/useIsMobile";
import useNetworkStatus from "hooks/useNetworkStatus";
import useSetOkuriList from "../../hooks/useSetOkuriList";
import useSetOrderList from "../../hooks/useSetOrderList";
import useSetTimeLineInfo from "../../hooks/useTimeLineInfo";
import useShowListStaff from "hooks/useShowListStaff";
import useUpdateTable from "hooks/useUpdateTable";
import { v4 as uuidv4 } from "uuid";

//import { useSetModal } from "../hooks/useSetModal";

enum OptionRandom {
  NORMAL = 1,
  WITH_COUNT = 2,
  WITH_RANKING = 3,
}
export const TakuSettei: FC<TakuTypeSettei> = (props) => {
  const {
    id,
    takuId,
    setShowModal,
    differTime,
    countNextBtn,
    handleSetOrderList,
    handleSetOkuriList,
    handleUpdateTableCode,
    okuriList,
    orderList,
    isSetup,
    infoTable,
    tableStarted,
    listStaffNotPriority,
    listStaffCandidacy,
    fromHistory,
  } = props;

  const index: number = id - 1;
  const { setOkuriList } = useSetOkuriList();
  const { calcNextTime } = useCalcEndTime();

  const { takuSettei, setTakuSettei } = useContext(TakuContext);
  const { staff, setStaffDrag } = useDragStaff();
  const { timeLineInfo, setTimeLineInfo } = useSetTimeLineInfo();
  const { setOrderList } = useSetOrderList();
  const { setValueUpdate } = useUpdateTable();
  const { isMobile } = useIsMobile();

  const [showOkuri, setShowOkuri] = useState<boolean>(false);
  const [showFullForm, setShowFullForm] = useState<boolean>(false);

  const [form] = Form.useForm();
  const queryClient = useQueryClient();

  const [takuForm, setTakuForm] = useState<TakuTypeSettei>({
    ...takuSettei[index],
  });
  const [takuAlphaForm, setTakuAlpheForm] = useState<string>("A");
  const [takuNumberForm, setTakuNumberForm] = useState<string>("1");
  const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
  const isOnline = useNetworkStatus();
  const timeLineDataOffline = useRef<string[]>([]);
  const [listDrinkAgain, setListDrinkAgain] = useState<number[]>([]);

  const [customer, setCustomer] = useState<string>("");
  const typeRandom = useRef<OptionRandom>(OptionRandom.NORMAL);

  const { data: defaultConfig } = useQuery(queryKeys.defaultConfigTable) as any;
  const { data: staffList } = useQuery(queryKeys.listHost, {}) as any;

  const timelineInfoBeforeRandom = useRef<TakuTypeSettei[]>([]);
  const { inRandom, setInRandom } = useInRandom();

  const userPlan = Cookies.get("userPlan");
  const { data: staffCount } = useQuery(
    queryKeys.staffCount,
    getListHostCount
  ) as any;

  const {
    data: listTableSession,
    isFetching,
    isLoading,
  } = useQuery(queryKeys.listTableSession, getListTableSession);

  useEffect(() => {
    if (isSetup) {
      setListDrinkAgain(infoTable?.listDrinkAgain || []);
      setTakuForm({ ...infoTable?.tableConfig, type: infoTable?.type });
      setTimeLineInfo(infoTable?.timeLineInfo);
      setTakuAlpheForm(infoTable?.tableConfig?.code);
      setTakuNumberForm(infoTable?.tableConfig?.no);
      setOrderList(infoTable?.orderList);
      setOkuriList(infoTable?.okuriList);
      form.setFieldsValue({
        ...infoTable?.tableConfig,
        memo: infoTable?.memo || "",
      });
      setCustomer(infoTable?.customer);
    } else {
      const offsetMinutes = Number(
        defaultConfig?.data?.startTimeOffsetMinutes ?? 2
      );
      form.setFieldsValue({
        ...defaultConfig?.data,
        startTime: moment().add(offsetMinutes, "m").format("HH:mm"),
      });
      setTakuForm({
        ...takuForm,
        ...defaultConfig?.data,
        startTime: moment().add(offsetMinutes, "m").format("HH:mm"),
        type: takuForm?.type,
      });
    }
  }, [infoTable, isSetup, defaultConfig]);

  useEffect(() => {
    if (!inRandom) {
      timelineInfoBeforeRandom.current = timeLineInfo;
    }
  }, [timeLineInfo, inRandom]);

  useEffect(() => {
    if (takuAlphaForm && takuNumberForm && handleUpdateTableCode) {
      handleUpdateTableCode(`${takuAlphaForm}${takuNumberForm}`);
    }
  }, [takuAlphaForm, takuNumberForm]);

  useEffect(() => {
    if (!infoTable) {
      setTimeLineInfo([]);
      setOrderList([]);
    }
  }, [infoTable]);

  const createTableSessionAction = useMutation(createTableSession);
  const updateTableSessionAction = useMutation(updateTableSession);
  const deleteTableSessionAction = useMutation(deleteTableSession);

  // 共通化したstate更新処理
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (Number(value) < Number(takuForm?.hime) && name === "hime") {
      const newOrderList = orderList?.filter((item: any) => {
        return Number(item?.index) < Number(value);
      }) as any[];
      const newOkuriList = okuriList?.filter((item: any) => {
        return Number(item?.index) < Number(value);
      }) as any[];
      const newListDrink = listDrinkAgain?.filter((item: any) => {
        return Number(item) < Number(value);
      }) as any[];
      setListDrinkAgain(newListDrink);
      setOkuriList(newOkuriList);
      setOrderList(newOrderList);
    }
    setTakuForm({ ...takuForm, [name]: value });
  };

  const handleChangeTime = (e: any) => {
    const { name, value } = e.target;
    const newTakuForm = { ...takuForm, [name]: value };
    if (!!value) {
      setTakuForm({ ...takuForm, [name]: value });
      setTakuSettei(() => takuSettei);

      if (!fromHistory) {
        takuSettei[index].startTime = newTakuForm.startTime;
      }
    }
  };

  const handleChangeSokai = (e: any) => {
    const selectedValue = e.target.value;
    setTakuForm({
      ...takuForm,
      type: Number(selectedValue),
    });
  };

  const handleChangeAlpha = (e: any) => {
    setTakuAlpheForm(e.target.value);
  };

  const handleChangeNumber = (e: any) => {
    setTakuNumberForm(e.target.value);
  };

  const saveTaku = () => {
    // const endTime = moment().set()
    const endTime = moment(takuForm.startTime, "HH:mm")
      .add(takuForm.courseTime, "m")
      .format("HH:mm");

    const valuesForm = form.getFieldsValue();
    if (!!infoTable) {
      // Check if edit table ended
      if (
        !!fromHistory &&
        moment(
          `${moment(infoTable?.date).format("YYYY-MM-DD")} ${
            takuForm?.startTime
          }`,
          "YYYY-MM-DD HH:mm"
        )
          .add(Number(takuForm.courseTime), "minutes")
          .isAfter(moment())
      ) {
        CustomNotification({
          type: "error",
          message: "終了時間を現在の時間以降設定できません。",
          description: "",
        });
        return;
      }
      updateTableSessionAction.mutate(
        {
          id: infoTable._id,
          data: {
            orderList,
            okuriList,
            tableConfig: {
              ..._.pick(takuForm, [
                "hime",
                "intervalTime",
                "courseTime",
                "timer",
                "startTime",
              ]),
              no: takuNumberForm,
              code: takuAlphaForm,
              endTime,
              utcOffset: moment().utcOffset(),
            },
            timeLineInfo,
            timeLineInfoReal: timeLineDataOffline?.current,
            index: id,
            type: takuForm.type || TableSessionType.First,
            memo: valuesForm?.memo || "",
            listStaffNotPriority,
            listStaffCandidacy,
            listDrinkAgain: listDrinkAgain,
            customer: customer,
          },
        },
        {
          onSuccess: (data) => {
            if (!!fromHistory) {
              queryClient.invalidateQueries(queryKeys.historyTable);
            } else {
              queryClient.invalidateQueries(queryKeys.listTableSession);
              queryClient.invalidateQueries(queryKeys.listStaffDuplicate);
            }

            closeModal();
          },
          onError: (err) => {
            if (!!isOnline) {
              handleErrorMessage(err);
              return;
            }
            const listTableSessionCurrent = queryClient.getQueryData(
              queryKeys.listTableSession
            ) as any;
            if (Array.isArray(listTableSessionCurrent?.data)) {
              const tableTmp = {
                orderList,
                okuriList,
                tableConfig: {
                  ..._.pick(takuForm, [
                    "hime",
                    "intervalTime",
                    "courseTime",
                    "timer",
                    "startTime",
                  ]),
                  no: takuNumberForm,
                  code: takuAlphaForm,
                  endTime,
                  utcOffset: moment().utcOffset(),
                },
                timeLineInfo,
                index: id,
                type: takuForm.type || TableSessionType.First,
                status: TableSessionStatus.NotStart,
                timeLineInfoReal: timeLineDataOffline.current,
                _id: infoTable?._id,
                step: 0,
                listStaffNotPriority,
                listStaffCandidacy,
                mustSync: true,
                listDrinkAgain: listDrinkAgain,
                customer: customer,
              };
              if (handleCheckDuplicateTable(tableTmp)) {
                CustomNotification({
                  type: "error",
                  description: "",
                  message: "存在している卓と重複しています。",
                });
                return;
              }
              const listTableSessionNew = listTableSessionCurrent?.data?.map(
                (item: any) => {
                  if (String(item?._id) === String(infoTable?._id)) {
                    return {
                      ...item,
                      orderList,
                      okuriList,
                      tableConfig: {
                        ..._.pick(takuForm, [
                          "hime",
                          "intervalTime",
                          "courseTime",
                          "timer",
                          "startTime",
                        ]),
                        no: takuNumberForm,
                        code: takuAlphaForm,
                        endTime,
                        utcOffset: moment().utcOffset(),
                      },
                      timeLineInfo,
                      index: id,
                      type: takuForm.type || TableSessionType.First,
                      listDrinkAgain: listDrinkAgain,
                    };
                  }
                  return item;
                }
              );
              queryClient.setQueryData(queryKeys.listTableSession, {
                data: listTableSessionNew,
              });
              setValueUpdate(uuidv4());

              closeModal();
            }
          },
        }
      );
      return;
    }
    createTableSessionAction.mutate(
      {
        orderList,
        okuriList,
        tableConfig: {
          ..._.pick(takuForm, [
            "hime",
            "intervalTime",
            "courseTime",
            "timer",
            "startTime",
          ]),
          no: takuNumberForm,
          code: takuAlphaForm,
          endTime,
          utcOffset: moment().utcOffset(),
        },
        timeLineInfo,
        index: id,
        type: takuForm.type || TableSessionType.First,
        customer: customer,
        memo: valuesForm?.memo || "",
        listStaffNotPriority,
        listStaffCandidacy,
        listDrinkAgain: listDrinkAgain,
      },
      {
        onSuccess: (data) => {
          queryClient.invalidateQueries(queryKeys.listTableSession);
          queryClient.invalidateQueries(queryKeys.listStaffDuplicate);
          queryClient.invalidateQueries(queryKeys.sortListTable);

          closeModal();
        },
        onError: (err) => {
          if (!!isOnline) {
            handleErrorMessage(err);
            return;
          }

          const tableTmp = {
            orderList,
            okuriList,
            tableConfig: {
              ..._.pick(takuForm, [
                "hime",
                "intervalTime",
                "courseTime",
                "timer",
                "startTime",
              ]),
              no: takuNumberForm,
              code: takuAlphaForm,
              endTime,
              utcOffset: moment().utcOffset(),
            },
            timeLineInfo,
            index: id,
            type: takuForm.type || TableSessionType.First,
            status: TableSessionStatus.NotStart,
            timeLineInfoReal: timeLineDataOffline.current,
            _id: uniqueId(),
            step: 0,
            listDrinkAgain: listDrinkAgain,
            listStaffNotPriority,
            listStaffCandidacy,
            mustSync: true,
          };
          if (handleCheckDuplicateTable(tableTmp)) {
            CustomNotification({
              type: "error",
              description: "",
              message: "存在している卓と重複しています。",
            });
            return;
          }

          const listTableSessionCurrent = (queryClient.getQueryData(
            queryKeys.listTableSession
          ) as any) || { data: [] };
          listTableSessionCurrent?.data?.push(tableTmp);
          queryClient.setQueryData(queryKeys.listTableSession, {
            data: [...listTableSessionCurrent?.data],
          });
          closeModal();
        },
      }
    );
  };

  const endTaku = () => {
    if (infoTable) {
      if (!showModalConfirm) {
        setShowModalConfirm(true);
        return;
      }
      deleteTableSessionAction.mutate(infoTable?._id, {
        onSuccess: (data) => {
          queryClient.invalidateQueries(queryKeys.listTableSession);
          queryClient.invalidateQueries(queryKeys.listStaffDuplicate);
          setShowModalConfirm(false);
          closeModal();
        },
        onError: (err) => {
          if (!!isOnline) {
            return;
          }
          const listTableSessionCurrent = queryClient.getQueryData(
            queryKeys.listTableSession
          ) as any;
          if (Array.isArray(listTableSessionCurrent?.data)) {
            const listTableSessionNew = listTableSessionCurrent?.data?.filter(
              (item: any) => {
                return String(item?._id) !== String(infoTable?._id);
              }
            );
            queryClient.setQueryData(queryKeys.listTableSession, {
              data: listTableSessionNew,
            });
            setValueUpdate(uuidv4());

            const listTableEndNotSyncString =
              localStorage.getItem("list-table-end");
            if (!!listTableEndNotSyncString) {
              try {
                const listTableEndNotSync = JSON.parse(
                  listTableEndNotSyncString
                );
                if (Array.isArray(listTableEndNotSync)) {
                  listTableEndNotSync.push({
                    ...infoTable,
                    status: TableSessionStatus.End,
                  });
                }
                localStorage.setItem(
                  "list-table-end",
                  JSON.stringify(listTableEndNotSync)
                );
              } catch (error) {}
            } else {
              localStorage.setItem(
                "list-table-end",
                JSON.stringify([
                  {
                    ...infoTable,
                    status: TableSessionStatus.End,
                  },
                ])
              );
            }
            closeModal();
          }
        },
      });
      return;
    }
    closeModal();
  };

  const handleCheckDuplicateTable = (table: any) => {
    let isDuplicate = false;
    const listConfigOfTable = queryClient.getQueryData(
      queryKeys.listTableSession
    ) as any;
    if (!Array.isArray(listConfigOfTable?.data)) {
      return false;
    }
    const listTableSessionOfNoCode = listConfigOfTable?.data?.filter(
      (item: any) =>
        item?.tableConfig?.no === table?.tableConfig?.no &&
        item?.tableConfig?.code === table?.tableConfig?.code &&
        item?._id !== table?._id
    );

    listTableSessionOfNoCode?.forEach((session: any) => {
      const isOverlap =
        moment(session?.tableConfig?.startTime, "HH:mm").isBetween(
          moment((table?.tableConfig as any)?.startTime, "HH:mm"),
          moment((table?.tableConfig as any)?.endTime, "HH:mm"),
          null,
          "()"
        ) ||
        moment(session?.tableConfig?.endTime, "HH:mm").isBetween(
          moment((table?.tableConfig as any)?.startTime, "HH:mm"),
          moment((table?.tableConfig as any)?.endTime, "HH:mm"),
          null,
          "()"
        ) ||
        moment((table?.tableConfig as any)?.startTime, "HH:mm").isBetween(
          moment(session?.tableConfig?.startTime, "HH:mm"),
          moment(session?.tableConfig?.endTime, "HH:mm"),
          null,
          "()"
        ) ||
        moment((table?.tableConfig as any)?.endTime, "HH:mm").isBetween(
          moment(session?.tableConfig?.startTime, "HH:mm"),
          moment(session?.tableConfig?.endTime, "HH:mm"),
          null,
          "()"
        ) ||
        (moment((table?.tableConfig as any)?.startTime, "HH:mm").isSame(
          moment(session?.tableConfig?.startTime, "HH:mm")
        ) &&
          moment((table?.tableConfig as any)?.endTime, "HH:mm").isSame(
            moment(session?.tableConfig?.endTime, "HH:mm")
          ));
      if (isOverlap) {
        isDuplicate = true;
      }
    });
    return isDuplicate;
  };
  const closeModal = () => {
    if (setShowModal != undefined) {
      setShowModal(false);
      setTimeLineInfo([]);
      setOrderList([]);
      setOkuriList([]);
      setInRandom(false);
    }
  };

  //--------ここからドラッグされたときの挙動--------//
  const dragStartStaff = (
    staff: StaffType,
    isOkuri: boolean,
    index: number
  ) => {
    setStaffDrag({ ...staff, isFromOrder: !isOkuri, index });
  };

  //--------ここからドロップされたときの挙動--------//
  const dragEnd = (e: React.DragEvent<HTMLDivElement>) => {};

  //ドラッグエリアに入ったらどうするか
  const onDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
    //console.log("on drag enter", e);
    //console.log(e.currentTarget.dataset.timelineindex);
    if (e.currentTarget.id === "drop-zone") {
      //setIsDroppable(true);
    }
  };

  //ドラッグされた場所で何をするか
  const onDropStaff = (index: number) => {
    if (Number(userPlan) === UserPlan.SubAccount) {
      return;
    }
    const listStaffInBlock = orderList?.filter(
      (item: any) => item.index === index
    );
    if (!staff) {
      return;
    }
    if (listStaffInBlock && listStaffInBlock?.length === 3) {
      CustomNotification({
        type: "error",
        description: "最大人数になりましたので、追加できません。",
        message: "",
      });
      return;
    }
    // if (!!infoTable) return;
    if (handleSetOrderList) {
      handleSetOrderList(index);
    }
  };

  const onDropStaffOkuri = (index: number) => {
    if (Number(userPlan) === UserPlan.SubAccount) {
      return;
    }
    const listStaffInBlock = okuriList?.filter(
      (item: any) => item.index === index
    );
    if (listStaffInBlock && listStaffInBlock?.length === 2) {
      CustomNotification({
        type: "error",
        description: "最大人数になりましたので、追加できません。",
        message: "",
      });
      return;
    }
    // if (!!infoTable) return;

    if (handleSetOkuriList) {
      handleSetOkuriList(index);
    }
  };

  const setTimelineData = (value: any) => {
    timeLineDataOffline.current = value;
  };

  const handleChangeCustomer = (e: any) => {
    setCustomer(e?.target?.value);
  };

  const handleChangeDrinkAgain = (e: any, index: number) => {
    let listDrinkAgainNew = [...listDrinkAgain];
    if (e?.target?.checked) {
      listDrinkAgainNew.push(index);
    } else {
      listDrinkAgainNew = listDrinkAgain.filter((item) => item !== index);
    }
    setListDrinkAgain(listDrinkAgainNew);
  };

  const getListStaffRandom = () => {
    const staffListWorking = staffList?.data?.filter((item: any) =>
      [StatusWorking.Working].includes(item?.infoWorking?.statusWorking)
    );

    const listStaffDrag =
      timelineInfoBeforeRandom.current.map((item: any) => item?.id) || [];

    let listStaffRandom = staffListWorking.filter(
      (item: any) => !listStaffDrag.includes(item.id)
    );

    if (defaultConfig?.data?.autoCandidacy === CommonStatus.ACTIVE) {
      listStaffRandom = listStaffRandom.filter((item: any) =>
        listStaffCandidacy?.includes(item.id)
      );
    } else {
      listStaffRandom = listStaffRandom.filter(
        (item: any) => !listStaffNotPriority?.includes(item.id)
      );
    }

    return listStaffRandom;
  };

  const getStaffAvailableWithTime = (withRanking?: boolean) => {
    const listStaffRandom = getListStaffRandom();
    const listStaffRandomClone = _.clone(listStaffRandom);
    const sortedRankingStaffIds = listStaffRandomClone
      .sort((a: any, b: any) => {
        // ranking = 0 is staff Not set => last priority
        if (a.rankingRandom === 0 && b.rankingRandom !== 0) {
          return 1;
        } else if (b.rankingRandom === 0 && a.rankingRandom !== 0) {
          return -1;
        } else {
          return a.rankingRandom - b.rankingRandom;
        }
      })
      .map((staff: any) => staff?.id);

    let divisionNum = Math.ceil(
      Number(takuForm?.courseTime) /
        (Number(takuForm?.timer) + Number(takuForm?.intervalTime))
    );

    let startTime = takuForm?.startTime;
    let listTimeOfTable = [startTime] as string[];

    for (let i = 0; i < divisionNum - 1; i++) {
      let nextTime = calcNextTime(
        startTime,
        Number(takuForm?.intervalTime),
        Number(takuForm?.timer)
      );
      startTime = nextTime;
      listTimeOfTable.push(nextTime);
    }
    listTimeOfTable = !!infoTable
      ? infoTable?.timeLineInfoReal
      : listTimeOfTable;
    let timeAvailable = {} as any;
    let timeWorkingOfStaff = {} as any;

    if (Array.isArray(listTableSession?.data)) {
      listTableSession?.data
        ?.filter((table: any) => table.status !== TableSessionStatus.End)
        ?.filter((table: any) => table?._id !== infoTable?._id)
        ?.forEach((table: any) => {
          if (Array.isArray(table.timeLineInfo)) {
            table.timeLineInfo?.forEach((timeline: any) => {
              const startTime =
                table.timeLineInfoReal?.[Number(timeline?.block)];
              const endTime =
                table.timeLineInfoReal?.[Number(timeline?.block) + 1];

              if (Object.keys(timeWorkingOfStaff)?.includes(timeline?.id)) {
                timeWorkingOfStaff[`${timeline?.id}`].push({
                  ...timeline,
                  startTime,
                  endTime,
                  tableConfig: table?.tableConfig,
                  dateReal: table?.dateReal,

                  timeLineInfoReal: table?.timeLineInfoReal,
                });
              } else {
                timeWorkingOfStaff[`${timeline?.id}`] = [
                  {
                    ...timeline,
                    startTime,
                    endTime,
                    tableConfig: table?.tableConfig,
                    dateReal: table?.dateReal,
                    timeLineInfoReal: table?.timeLineInfoReal,
                  },
                ];
              }
            });
          }
        });
    }
    timelineInfoBeforeRandom.current?.forEach((timeline: any) => {
      const startTime = timeline?.startTime;
      const endTime = timeline?.endTime;
      if (Object.keys(timeWorkingOfStaff)?.includes(timeline?.id)) {
        timeWorkingOfStaff[`${timeline?.id}`].push({
          ...timeline,
          startTime,
          endTime,
        });
      } else {
        timeWorkingOfStaff[`${timeline?.id}`] = [
          {
            ...timeline,
            startTime,
            endTime,
          },
        ];
      }
    });
    listTimeOfTable.forEach((time: string) => {
      timeAvailable[`${time}`] = [];
    });

    let dateReal = (infoTable as any)?.dateReal;
    if (!infoTable) {
      if (
        Math.abs(moment(takuForm?.startTime, "HH:mm").diff(moment(), "s")) >=
        12 * 60 * 60
      ) {
        if (moment(startTime, "HH:mm").isAfter(moment())) {
          dateReal = moment()
            .set({
              hour: moment(startTime, "HH:mm").hour(),
              minute: moment(startTime, "HH:mm").minute(),
              second: 0,
            })
            .subtract(1, "day")
            .toISOString();
        } else {
          dateReal = moment()
            .set({
              hour: moment(startTime, "HH:mm").hour(),
              minute: moment(startTime, "HH:mm").minute(),
              second: 0,
            })

            .add(1, "day")
            .toISOString();
        }
      } else {
        dateReal = moment();
      }
    }
    listTimeOfTable.forEach((time: string) => {
      const timeOfBlock =
        Number(takuForm?.timer) + Number(takuForm.intervalTime);
      const startTime = moment(dateReal).set({
        hour: moment(time, "HH:mm").hours(),
        minute: moment(time, "HH:mm").minutes(),
        second: 0,
        millisecond: 0,
      });

      if (
        toMinutes(startTime.format("HH:mm")) < toMinutes(takuForm?.startTime)
      ) {
        startTime.add(1, "day");
      }
      const endTime = startTime.clone().add(timeOfBlock, "minutes");
      listStaffRandom.forEach((staff: any) => {
        const listTimeOfStaff = timeWorkingOfStaff?.[`${staff.id}`];
        let isDuplicate = false;
        if (Array.isArray(listTimeOfStaff)) {
          listTimeOfStaff?.forEach((timeItem: any) => {
            const startTimeString = timeItem?.timeLineInfoReal?.find(
              (_: any, index: number) => index === Number(timeItem?.block)
            );

            const endTimeString = timeItem?.timeLineInfoReal?.find(
              (_: any, index: number) => index === timeItem?.block + 1
            );
            const timelineEndTime = moment(timeItem?.dateReal).set({
              hour: parseInt(endTimeString?.split(":")[0], 10),
              minute: parseInt(endTimeString?.split(":")[1], 10),
              second: 0,
              millisecond: 0,
            });

            const timelineStartTime = moment(timeItem?.dateReal).set({
              hour: parseInt(startTimeString?.split(":")[0], 10),
              minute: parseInt(startTimeString?.split(":")[1], 10),
              second: 0,
              millisecond: 0,
            });

            const startTimeMinutes =
              timelineStartTime.get("hour") * 60 +
              timelineStartTime.get("minute");
            const configStartMinutes =
              moment(timeItem?.tableConfig?.startTime, "HH:mm").get("hour") *
                60 +
              moment(timeItem?.tableConfig?.startTime, "HH:mm").get("minute");

            if (startTimeMinutes < configStartMinutes) {
              timelineStartTime.add(1, "day");
            }

            const endTimeMinutes =
              timelineEndTime.get("hour") * 60 + timelineEndTime.get("minute");
            if (endTimeMinutes < configStartMinutes) {
              timelineEndTime.add(1, "day");
            }

            if (
              startTime.isBetween(
                timelineStartTime,
                timelineEndTime,
                null,
                "()"
              ) ||
              endTime.isBetween(
                timelineStartTime,
                timelineEndTime,
                null,
                "()"
              ) ||
              timelineStartTime.isBetween(startTime, endTime, null, "()") ||
              timelineEndTime.isBetween(startTime, endTime, null, "()") ||
              (startTime.isSame(timelineStartTime) &&
                endTime.isSame(timelineEndTime))
            ) {
              isDuplicate = true;
            }
          });
        }
        if (!isDuplicate) {
          timeAvailable[`${time}`].push(staff.id);
        }
      });
      if (withRanking) {
        timeAvailable[`${time}`].sort((a: any, b: any) => {
          return (
            sortedRankingStaffIds.indexOf(a) - sortedRankingStaffIds.indexOf(b)
          );
        });
      }
    });
    return timeAvailable;
  };

  const handleRandomStaff = (isPriority?: boolean) => {
    const listStaffCount = staffCount.data;
    let listStaffRandom = getListStaffRandom();

    let listPriorityStaff = null as any;
    if (isPriority) {
      listStaffRandom?.forEach((staff: any) => {
        if (!Object.keys(listStaffCount).includes(staff.id)) {
          listStaffCount[`${staff?.id}`] = 0;
        }
      });
      const groupedStaff = _.groupBy(_.toPairs(listStaffCount), 1);
      const sortedListStaffCount = _.fromPairs(
        _.flatMap(
          _.sortBy(Object.keys(groupedStaff).map(Number), (value) => value).map(
            (value) => _.shuffle(groupedStaff[value])
          )
        )
      );
      listPriorityStaff = sortedListStaffCount;
    }

    setInRandom(true);
    const staffAvailableWithTime = getStaffAvailableWithTime();
    const totalTime =
      Number(takuForm?.courseTime) +
      (Number((infoTable as any)?.totalDifferentTime) || 0) / 60;

    let divisionNum = Math.ceil(
      totalTime / (Number(takuForm?.timer) + Number(takuForm?.intervalTime))
    );

    let startTime = takuForm?.startTime;
    let listTimeOfTable = [startTime] as string[];

    for (let i = 0; i < divisionNum - 1; i++) {
      let nextTime = calcNextTime(
        startTime,
        Number(takuForm?.intervalTime),
        Number(takuForm?.timer)
      );
      startTime = nextTime;
      listTimeOfTable.push(nextTime);
    }

    listTimeOfTable = !!infoTable
      ? infoTable?.timeLineInfoReal
      : listTimeOfTable;

    const timelineInfoNew = [...timelineInfoBeforeRandom.current];

    const staffNotFill = Math.max(
      listStaffRandom.length -
        (!!infoTable ? -timelineInfoNew.length : timelineInfoNew.length),
      0
    );
    let listIndexShuffle = [] as any[];
    const totalBlockRandom = Math.min(
      divisionNum,
      Math.ceil(staffNotFill / Number(takuForm.hime))
    );
    const totalStaffNotFill = Math.max(
      totalBlockRandom * Number(takuForm.hime) - staffNotFill,
      0
    );

    for (let t = 0; t < totalBlockRandom; t++) {
      listIndexShuffle.push(t);
    }

    for (let k = 0; k < listIndexShuffle.length; k++) {
      const t = listIndexShuffle?.[k];

      const startTimeOfBlock = listTimeOfTable?.[t];
      const endTimeOfBlock = moment(startTimeOfBlock, "HH:mm")
        .add(Number(takuForm.intervalTime) + Number(takuForm?.timer), "minutes")
        .format("HH:mm");
      const staffInBlock = timelineInfoBeforeRandom.current.filter(
        (item: any) =>
          item?.block === t && item?.index <= 3 - Number(takuForm?.hime)
      );
      let staffInEachBlock = Number(takuForm?.hime) - staffInBlock?.length;

      if (t === totalBlockRandom - 1) {
        staffInEachBlock = staffInEachBlock - totalStaffNotFill;
      }
      let listStaff = staffAvailableWithTime?.[startTimeOfBlock];
      if (!listStaff) continue;
      for (let i = 0; i < staffInEachBlock; i++) {
        const index = 3 - i;

        const staff = timelineInfoBeforeRandom.current.find(
          (item: any) => item?.block === t && item?.index === index
        );
        if (!!staff) continue;

        let randomStaffId: any = undefined,
          randomStaff: any = undefined;
        if (isPriority) {
          let staffIndex = 0;
          let sortedStaffIds = Object.keys(listPriorityStaff);

          while (!randomStaff && sortedStaffIds?.length > 0) {
            const randomStaffId = sortedStaffIds[staffIndex];

            if (listStaff.includes(randomStaffId)) {
              randomStaff = listStaffRandom?.find(
                (item: any) => item?.id === randomStaffId
              );
            }

            if (!randomStaff) {
              staffIndex++;

              if (staffIndex >= sortedStaffIds.length) {
                break;
              }
            } else {
              delete listPriorityStaff[randomStaffId];
              staffIndex = 0;
            }
          }
        } else {
          while (!randomStaff && listStaff?.length > 0) {
            randomStaffId = _.sample(listStaff);
            randomStaff = listStaffRandom?.find(
              (item: any) => item?.id === randomStaffId
            );
            if (!randomStaff) {
              listStaff = listStaff?.filter(
                (item: any) => item !== randomStaffId
              );
            }
          }
        }

        if (!randomStaff) {
          continue;
        }
        listStaffRandom = listStaffRandom.filter(
          (item: any) => item?.id !== randomStaffId
        );

        timelineInfoNew.push({
          ...randomStaff,
          index: index,
          block: t,
          startTime: startTimeOfBlock,
          endTime: endTimeOfBlock,
          infoSession: infoTable,
        });
        if (listStaffRandom.length === 0) break;
      }
    }
    setTimeLineInfo(timelineInfoNew);
  };

  const handleRandomStaffWithRanking = () => {
    let listStaffRandom = getListStaffRandom();

    setInRandom(true);
    let listStaffRandomHasRanking = listStaffRandom.filter(
      (item: any) => item.rankingRandom > 0
    );
    const staffAvailableWithTime = getStaffAvailableWithTime(true);
    const totalTime =
      Number(takuForm?.courseTime) +
      (Number((infoTable as any)?.totalDifferentTime) || 0) / 60;

    let divisionNum = Math.ceil(
      totalTime / (Number(takuForm?.timer) + Number(takuForm?.intervalTime))
    );

    let startTime = takuForm?.startTime;
    let listTimeOfTable = [startTime] as string[];

    for (let i = 0; i < divisionNum - 1; i++) {
      let nextTime = calcNextTime(
        startTime,
        Number(takuForm?.intervalTime),
        Number(takuForm?.timer)
      );
      startTime = nextTime;
      listTimeOfTable.push(nextTime);
    }
    listTimeOfTable = !!infoTable
      ? infoTable?.timeLineInfoReal
      : listTimeOfTable;

    const timelineInfoNew = [...timelineInfoBeforeRandom.current];

    // get length with 5 staff {index: ?, block: ?, startTimeOfBlock: ?, endTimeOfBlock: ?}
    let listIndexBlockRandom = [] as any[];
    for (let t = divisionNum - 1; t >= 0; t--) {
      const startTimeOfBlock = listTimeOfTable?.[t];
      const endTimeOfBlock = moment(startTimeOfBlock, "HH:mm")
        .add(Number(takuForm.intervalTime) + Number(takuForm?.timer), "minutes")
        .format("HH:mm");

      const staffInBlock = timelineInfoBeforeRandom.current.filter(
        (item: any) =>
          item?.block === t && item?.index <= 3 - Number(takuForm?.hime)
      );

      const staffInEachBlock = Number(takuForm?.hime) - staffInBlock?.length;
      if (staffInEachBlock < 0) continue;

      for (let i = 0; i < staffInEachBlock; i++) {
        const index = 3 - i;

        listIndexBlockRandom.push({
          index,
          block: t,
          startTimeOfBlock,
          endTimeOfBlock,
        });
        if (
          listIndexBlockRandom.length < 5 &&
          !(t === 0 && i === staffInEachBlock - 1)
        ) {
          continue;
        } else {
          if (
            (listStaffRandom.length >= 5 &&
              listStaffRandomHasRanking.length >= 5) ||
            (listStaffRandom.length >= 5 &&
              listStaffRandomHasRanking.length === 0)
          ) {
            listIndexBlockRandom = _.shuffle(listIndexBlockRandom);
          }
          for (let j = 0; j < listIndexBlockRandom.length; j++) {
            const infoStep = listIndexBlockRandom?.[j];
            const staff = timelineInfoBeforeRandom.current.find(
              (item: any) =>
                item?.block === infoStep?.block &&
                item?.index === infoStep?.index
            );
            if (!!staff) continue;
            let listStaff =
              staffAvailableWithTime?.[infoStep?.startTimeOfBlock];
            let randomStaffId: any = undefined,
              randomStaff: any = undefined;
            while (!randomStaff && listStaff?.length > 0) {
              if (listStaffRandomHasRanking.length === 0) {
                randomStaffId = _.sample(listStaff);
                randomStaff = listStaffRandom?.find(
                  (item: any) => item?.id === randomStaffId
                );
                if (!randomStaff) {
                  listStaff = listStaff?.filter(
                    (item: any) => item !== randomStaffId
                  );
                }
              } else {
                randomStaffId = _.first(listStaff);
                _.pullAt(listStaff, 0);
                randomStaff = listStaffRandom?.find(
                  (item: any) => item?.id === randomStaffId
                );
              }
            }

            if (!randomStaff) {
              continue;
            }
            listStaffRandom = listStaffRandom.filter(
              (item: any) => item?.id !== randomStaffId
            );
            listStaffRandomHasRanking = listStaffRandomHasRanking.filter(
              (item: any) => item?.id !== randomStaffId
            );
            timelineInfoNew.push({
              ...randomStaff,
              index: infoStep?.index,
              block: infoStep?.block,
              startTime: infoStep?.startTimeOfBlock,
              endTime: infoStep?.endTimeOfBlock,
              infoSession: infoTable,
            });
            if (listStaffRandom.length === 0) break;
          }
          listIndexBlockRandom = [];
        }
      }
    }
    setTimeLineInfo(timelineInfoNew);
  };

  const submitButtonRandom = () => {
    switch (typeRandom.current) {
      case OptionRandom.WITH_COUNT:
        handleRandomStaff(true);
        break;

      case OptionRandom.WITH_RANKING:
        handleRandomStaffWithRanking();
        break;

      default:
        handleRandomStaff();
        break;
    }
  };

  const handleChangeTypeRandom = (value: OptionRandom) => {
    typeRandom.current = value;
  };

  const handleClearTimeLine = () => {
    if (!infoTable) {
      timelineInfoBeforeRandom.current = [];
      setTimeLineInfo([]);
      return;
    }
    if (!Array.isArray(timeLineInfo)) return;
    const timeLine = timeLineInfo.filter(
      (item: any) => Number(item?.block) <= Number(infoTable?.step)
    );
    timelineInfoBeforeRandom.current = timeLine;
    setTimeLineInfo(timeLine);
  };

  return (
    <>
      {(isLoading || isFetching) && (
        <div className={styles.loadingContainer}>
          <Spin spinning={true} />
        </div>
      )}
      <div
        className={classNames("takuSettei", {
          [styles.has3himeTaku]: Number(takuForm?.hime) === 3,
          [styles.inMobile]: !!isMobile,
        })}
      >
        <h2 className={styles.header}>
          <div className={styles.col1}>
            {takuId} 設定画面
            <div className={styles.customerContainer}>
              {!isMobile && "名前"}
              <Input onChange={handleChangeCustomer} value={customer} />様
            </div>
          </div>
          <span className={styles.col2}>
            <input
              type="radio"
              name="shokai"
              onChange={handleChangeSokai}
              value={TableSessionType.First}
              checked={takuForm?.type === TableSessionType.First || !infoTable}
            />
            初回　
            <input
              type="radio"
              name="shokai"
              onChange={handleChangeSokai}
              value={TableSessionType.Referral}
              checked={takuForm?.type === TableSessionType.Referral}
            />
            枝フリー　
            <input
              type="radio"
              name="shokai"
              onChange={handleChangeSokai}
              value={TableSessionType.Peer}
              checked={takuForm?.type === TableSessionType.Peer}
            />
            同業
          </span>
        </h2>
        <Form
          form={form}
          className={classNames("kihon", styles.formSetting, {
            [styles.has2HomeForm]: Number(takuForm?.hime) === 2,
            [styles.has3HomeForm]: Number(takuForm?.hime) === 3,
          })}
          layout={isMobile ? "horizontal" : "horizontal"}
        >
          {isMobile ? (
            <>
              <Row className={styles.rowInfo}>
                <Form.Item name="code" label="卓番号">
                  <select
                    name="code"
                    className="takuAlphaForm"
                    onChange={handleChangeAlpha}
                  >
                    {(
                      defaultConfig?.data?.tableCodeOptions ?? [
                        "A",
                        "B",
                        "C",
                        "D",
                        "E",
                        "F",
                        "G",
                        "H",
                        "I",
                        "J",
                        "K",
                        "V",
                        "X",
                        "S",
                        "M",
                      ]
                    ).map((opt: string) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </Form.Item>

                <Form.Item name="no" label="" className={styles.noSelector}>
                  <select
                    name="no"
                    className="takuNumberForm"
                    onChange={handleChangeNumber}
                  >
                    {(
                      defaultConfig?.data?.tableNoOptions ?? [
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                        "7",
                        "8",
                        "9",
                        "10",
                        "11",
                        "12",
                        "13",
                        "14",
                        "15",
                        "16",
                        "17",
                        "18",
                        "19",
                        "20",
                      ]
                    ).map((opt: string) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </Form.Item>
              </Row>
              <Row className={styles.rowInfo}>
                <Form.Item name="startTime" label="開始時間　">
                  <input
                    type="time"
                    name="startTime"
                    //defaultValue={takuSettei[index].startTime}
                    value={takuForm.startTime}
                    onChange={handleChangeTime}
                    disabled={!!isSetup && !!tableStarted && !fromHistory}
                  />
                </Form.Item>
              </Row>
            </>
          ) : (
            <Row className={styles.rowInfo}>
              <Col xs={12}>
                <Row align="middle">
                  <Form.Item name="code" label="卓番号">
                    <select
                      name="code"
                      className="takuAlphaForm"
                      onChange={handleChangeAlpha}
                    >
                      {(
                        defaultConfig?.data?.tableCodeOptions ?? [
                          "A",
                          "B",
                          "C",
                          "D",
                          "E",
                          "F",
                          "G",
                          "H",
                          "I",
                          "J",
                          "K",
                          "V",
                          "X",
                          "S",
                          "M",
                        ]
                      ).map((opt: string) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </Form.Item>

                  <Form.Item name="no" className={styles.noSelector}>
                    <select
                      name="no"
                      className="takuNumberForm"
                      onChange={handleChangeNumber}
                    >
                      {(
                        defaultConfig?.data?.tableNoOptions ?? [
                          "1",
                          "2",
                          "3",
                          "4",
                          "5",
                          "6",
                          "7",
                          "8",
                          "9",
                          "10",
                          "11",
                          "12",
                          "13",
                          "14",
                          "15",
                          "16",
                          "17",
                          "18",
                          "19",
                          "20",
                        ]
                      ).map((opt: string) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </Form.Item>
                </Row>
              </Col>
              <Col xs={12}>
                <Form.Item name="startTime" label="開始時間　">
                  <input
                    type="time"
                    name="startTime"
                    //defaultValue={takuSettei[index].startTime}
                    value={takuForm.startTime}
                    onChange={handleChangeTime}
                    disabled={!!isSetup && !!tableStarted && !fromHistory}
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row className={styles.rowInfo}>
            <Col xs={isMobile ? 24 : 12}>
              <Row align={"middle"}>
                <Form.Item name="courseTime" label="コース時間">
                  <select
                    name="courseTime"
                    onChange={handleChange}
                    disabled={!!isSetup && !fromHistory}
                    // defaultValue={takuSettei[index].courseTime}
                  >
                    <option value="30">30</option>
                    <option value="60">60</option>
                    <option value="90">90</option>
                    <option value="120">120</option>
                  </select>
                </Form.Item>
                分
              </Row>
            </Col>
            <Col xs={isMobile ? 24 : 12} className={styles.colMobile}>
              <Row align={"middle"}>
                <Form.Item name="timer" label="着席時間">
                  <select
                    name="timer"
                    onChange={handleChange}
                    disabled={!!isSetup && !fromHistory}

                    // defaultValue={takuSettei[index].timer}
                  >
                    {Array.from({
                      length:
                        Number(defaultConfig?.data?.timerMax) -
                        Number(defaultConfig?.data?.timerMin) +
                        1,
                    }).map((_, index) => (
                      <option
                        value={Number(defaultConfig?.data?.timerMin) + index}
                      >
                        {Number(defaultConfig?.data?.timerMin) + index}
                      </option>
                    ))}
                  </select>
                </Form.Item>
                分
              </Row>
            </Col>
          </Row>
          <datalist id="takuList1">
            <option value="A"></option>
            <option value="B"></option>
            <option value="C"></option>
            <option value="D"></option>
            <option value="E"></option>
            <option value="F"></option>
          </datalist>
          <datalist id="takuList2">
            <option value="1"></option>
            <option value="2"></option>
            <option value="3"></option>
            <option value="4"></option>
            <option value="5"></option>
            <option value="6"></option>
            <option value="7"></option>
            <option value="8"></option>
            <option value="9"></option>
            <option value="10"></option>
          </datalist>

          <Row className={styles.rowInfo}>
            <Col xs={isMobile ? 24 : 12}>
              <Row align={"middle"}>
                <Form.Item name="intervalTime" label="ロスタイム">
                  <select
                    name="intervalTime"
                    onChange={handleChange}
                    disabled={!!isSetup && !fromHistory}
                  >
                    {Array.from({
                      length:
                        Number(defaultConfig?.data?.intervalTimeMax) -
                        Number(defaultConfig?.data?.intervalTimeMin) +
                        1,
                    }).map((_, index) => (
                      <option
                        value={
                          Number(defaultConfig?.data?.intervalTimeMin) + index
                        }
                      >
                        {Number(defaultConfig?.data?.intervalTimeMin) + index}
                      </option>
                    ))}
                  </select>
                </Form.Item>
                分
              </Row>
            </Col>

            <Col
              xs={isMobile ? 24 : 12}
              className={classNames(styles.colMobile, {
                [styles.displayNone]: !(
                  (isMobile && showFullForm) ||
                  !isMobile
                ),
              })}
            >
              <Row align={"middle"}>
                <Form.Item name="hime" label="来店人数">
                  <select
                    name="hime"
                    onChange={handleChange}
                    disabled={!!isSetup && !fromHistory}
                  >
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                  </select>
                </Form.Item>
                名
              </Row>
            </Col>
          </Row>

          <>
            <Row
              className={classNames(styles.rowInfo, styles.memoRow, {
                [styles.memoMobile]: !!isMobile,
                [styles.displayNone]: !(
                  (isMobile && showFullForm) ||
                  !isMobile
                ),
              })}
            >
              <Col xs={24}>
                <Form.Item name="memo" label="メモ欄">
                  <TextArea autoSize={{ minRows: 1 }} />
                </Form.Item>
              </Col>
            </Row>
          </>

          {isMobile && (
            <div
              className={classNames(styles.btnShowOkuri, {
                [styles.show]: !!showFullForm,
              })}
            >
              <Button onClick={() => setShowFullForm(!showFullForm)}>
                もっとみる
              </Button>
            </div>
          )}
        </Form>
        <h3>写真指名と送り指名</h3>
        <div className="shimeiOkuriWrapoer clearfix">
          <div className="shimei">
            {Array.from({ length: Number(takuForm.hime) }).map(
              (item, index) => (
                <dl key={index + 1}>
                  <dd
                    style={{
                      backgroundColor: `${colors[index]}`,
                      color: "#fff",
                    }}
                  >
                    写真指名{index + 1}
                  </dd>
                  <dt
                    onDragEnd={dragEnd}
                    onDragEnter={onDragEnter}
                    onDragOver={(e) => {
                      e.preventDefault(); // これがないとdropイベントが発火しない
                    }}
                    onDrop={() => onDropStaff(index)}
                  >
                    <ul>
                      {orderList
                        ?.filter((item: any) => Number(item.index) === index)
                        ?.map((item: any, orderIndex) => {
                          return (
                            <li
                              draggable={true}
                              onDragStart={() =>
                                dragStartStaff(item?.staff, false, index)
                              }
                            >
                              {displayStaffName(item?.staff?.staffName)}
                            </li>
                          );
                        })}
                    </ul>
                  </dt>
                </dl>
              )
            )}
          </div>

          <div
            className={classNames("okuri", {
              [styles.displayNone]: !((isMobile && showOkuri) || !isMobile),
            })}
          >
            <div className={styles.drinkingAgainTitle}>
              <div>飲み直し</div>
            </div>
            {Array.from({ length: Number(takuForm.hime) }).map(
              (item, index) => (
                <dl
                  key={index}
                  className={classNames({
                    [styles.lastRow]: index === Number(takuForm?.hime) - 1,
                  })}
                >
                  <dd
                    style={{
                      backgroundColor: `${colors[index]}`,
                      color: "#fff",
                    }}
                  >
                    送り指名{index + 1}
                  </dd>
                  <dt
                    onDragEnd={dragEnd}
                    onDragEnter={onDragEnter}
                    onDragOver={(e) => {
                      e.preventDefault(); // これがないとdropイベントが発火しない
                    }}
                    onDrop={() => onDropStaffOkuri(index)}
                  >
                    <ul>
                      {okuriList
                        ?.filter((item: any) => Number(item.index) === index)
                        ?.map((item: any, orderIndex) => {
                          return (
                            <li
                              draggable={true}
                              onDragStart={() =>
                                dragStartStaff(item?.staff, true, index)
                              }
                            >
                              {displayStaffName(item?.staff?.staffName)}
                            </li>
                          );
                        })}
                    </ul>
                  </dt>
                  <div className={styles.drinkingAgainItem}>
                    <Checkbox
                      checked={listDrinkAgain?.includes(index)}
                      onChange={(e) => handleChangeDrinkAgain(e, index)}
                    />
                  </div>
                </dl>
              )
            )}
          </div>
          {isMobile && (
            <div
              className={classNames(styles.btnShowOkuri, {
                [styles.show]: !!showOkuri,
              })}
            >
              <Button onClick={() => setShowOkuri(!showOkuri)}>
                もっとみる
              </Button>
            </div>
          )}
        </div>
        <h3>スタッフタイムテーブル</h3>

        <TimeLine
          id={id}
          infoTable={infoTable}
          takuId={takuId}
          startTime={takuForm?.startTime}
          courseTime={takuForm?.courseTime}
          intervalTime={takuForm?.intervalTime}
          timer={takuForm?.timer}
          // seatingList={takuSettei?.[index]?.seatingList}
          differTime={differTime}
          countNextBtn={countNextBtn}
          setTimelineData={setTimelineData}
          cls={classNames({
            [styles.has2himeTimeLine]: Number(takuForm?.hime) === 2,
            [styles.has3himeTimeLine]: Number(takuForm?.hime) === 3,
          })}
          fromHistory={fromHistory}
        />
        {Number(userPlan) !== UserPlan.SubAccount && (
          <div className={styles.btnRandomContainer}>
            <Select
              className={styles.selectTypeRandom}
              defaultValue={typeRandom.current}
              options={[
                {
                  value: OptionRandom.NORMAL,
                  label: "ランダム配置",
                },
                {
                  value: OptionRandom.WITH_COUNT,
                  label: "回数均等配置",
                },
                {
                  value: OptionRandom.WITH_RANKING,
                  label: "ランカー優先配置",
                },
              ]}
              onChange={handleChangeTypeRandom}
            ></Select>
            <Button
              onClick={() => submitButtonRandom()}
              disabled={isFetching || isLoading}
            >
              配置
            </Button>
            <Button
              onClick={() => handleClearTimeLine()}
              disabled={isFetching || isLoading}
            >
              リセット
            </Button>
          </div>
        )}

        <p
          className={classNames("setteiButton", {
            [styles.has2hime]: Number(takuForm?.hime) === 2,
          })}
        >
          {Number(userPlan) !== UserPlan.SubAccount && (
            <button className="setteiHozon" onClick={saveTaku}>
              設定する
            </button>
          )}

          {Number(userPlan) !== UserPlan.SubAccount && (
            <button
              className={classNames("setteiEnd", {
                ["disableBtn"]: fromHistory,
              })}
              onClick={endTaku}
              disabled={fromHistory}
            >
              卓を終了
            </button>
          )}
          <button className="setteiCansel" onClick={closeModal}>
            戻る
          </button>
        </p>
      </div>

      <ModalConfirm
        isVisible={showModalConfirm}
        textCancel={"いいえ"}
        textOke={"はい"}
        header="確認"
        title={"卓を終了しますか？"}
        handleCancel={() => setShowModalConfirm(false)}
        handleClose={() => setShowModalConfirm(false)}
        handleOke={endTaku}
        closeIcon={false}
        closable={false}
      />
      {/* </TakuProvider> */}
    </>
  );
};
